import { createContext, useContext } from 'react';
import { SidebarMode } from 'utils/sidebar-mode';

interface ContextValues {
  openSearch: () => void;
  leftNavDrawerOpen: boolean;
  toggleLeftNavDrawer: () => void;
  /** Effective collapsed state of the left sidebar on desktop (80px rail vs 240px). */
  sidebarCollapsed: boolean;
  sidebarMode: SidebarMode;
  setSidebarMode: (mode: SidebarMode) => void;
  /** True where hovering should float the sidebar open over the page instead of reflowing it. */
  sidebarCanPeek: boolean;
  /** Manual mode answers a hover with an edge handle rather than opening by itself. */
  toggleManualCollapsed: () => void;
  /** This route fits the viewport; each column scrolls itself instead of growing the page. */
  fullHeight: boolean;
}

export const PageContext = createContext<ContextValues>({
  openSearch: () => {},
  leftNavDrawerOpen: false,
  toggleLeftNavDrawer: () => null,
  sidebarCollapsed: false,
  sidebarMode: 'auto',
  setSidebarMode: () => null,
  sidebarCanPeek: false,
  toggleManualCollapsed: () => null,
  fullHeight: false,
});

export const usePageContext = (): ContextValues => useContext(PageContext);
